import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {};

const setFeatureSwitches = (draft, action) => {
  const {
    featureSwitches
  } = action.payload;
  featureSwitches.forEach(feature => {
    draft[feature.name] = feature.enabled;
  });
};

const featureSwitchesSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setFeatureSwitches
  }
});
export const {
  actions
} = featureSwitchesSlice;
export const plug = {
  [stateName]: featureSwitchesSlice.reducer
};
export default featureSwitchesSlice.reducer;